import React, { useState } from "react";
import "./TechnologyStack.css";
// import tech1 from "../../img/icon-programing-01.png";
import tech2 from "../../img/icon-programing-02.png";
// import tech3 from "../../img/icon-programing-03.png";
import tech4 from "../../img/icon-programing-04.png";
// import tech5 from "../../img/icon-programing-05.png";
// import tech6 from "../../img/icon-programing-06.png";
import tech7 from "../../img/icon-programing-07.png";
// import nextjs from "../../img/nextjs.png";
 import tailwind from "../../img/tailwindcss.png";
 import bootstrap from "../../img/bootstrap.png";
 import typescript from "../../img/typescript.png";
 import django from "../../img/django.png";
 import mern from "../../img/mern.png";
 import php from "../../img/php.png";
 import java from "../../img/java.png";
 import aws from "../../img/aws.jpg";
 import google_cloud from "../../img/google-cloud.webp";
 import azure from "../../img/azure.jpg";
 import ibm from "../../img/ibm.png";
 import docker from "../../img/docker.png";
 import kubernetes from "../../img/kubernetes.jpg";



import tech8 from "../../img/icon-programing-08.png";
import tech9 from "../../img/icon-programing-09.png";
import tech10 from "../../img/icon-programing-10.png";
import tech11 from "../../img/icon-programing-11.png";
// import tech12 from "../../img/icon-programing-12.png";
import tech13 from "../../img/icon-programing-13.png";


export default function TechnologyStack() {
  const [selectedTech, setSelectedTech] = useState("Frontend Technologies");

  const values = [
    {
      id: "01/",
      title: "Frontend Technologies",
      sections: [
        {
          heading: "Frameworks & Libraries",
          logos: [
            { name: "React.js", img: tech7, description: "A JavaScript library for building user interfaces with reusable components." },
            { name: "Next.js", img: tech13, description: "A React framework that provides server-side rendering and static site generation for enhanced performance." },
            { name: "TypeScript", img: typescript, description: "A superset of JavaScript that adds static typing, making code more robust and easier to debug." },
            { name: "Material UI", img: tech4, description: "A popular React UI framework offering pre-built components following Google's Material Design principles." },
          ],
        },
        {
          heading: "Styling & APIs",
          logos: [
            { name: "Tailwind CSS", img: tailwind, description: "A utility-first CSS framework for creating fast and responsive designs." },
            { name: "Bootstrap", img: bootstrap, description: "A popular CSS framework for building responsive, mobile-first websites." },
            { name: "REST API", img: tech8, description: "An architectural style for designing networked applications using stateless communication." },
            // { name: "Ant Design", img: tech7, description: "A comprehensive design system and UI library for building enterprise-grade applications." },
          ],
        },
      ],
    },
    {
      id: "02/",
      title: "Backend Technologies",
      sections: [
        {
          heading: "Languages & Frameworks",
          logos: [
            { name: "Django", img: django, description: "A high-level Python framework for rapid development of secure and maintainable web applications." },
            { name: "MERN Stack", img: mern, description: "A stack that includes MongoDB, Express.js, React, and Node.js for full-stack JavaScript development." },
            { name: "Node.js", img: tech9, description: "A runtime for executing JavaScript on the server side, ideal for building scalable web applications." },
            { name: "PHP", img: php, description: "A general-purpose scripting language widely used for server-side web development." },
            { name: "Laravel", img: tech11, description: "A PHP framework that simplifies complex tasks such as authentication, routing, and caching." },
            { name: "Java", img: java, description: "A versatile programming language known for its portability, security, and scalability." },
          ],
        },
      ],
    },
    {
      id: "03/",
      title: "Cloud & DevOps",
      sections: [
      
        {
          heading: "Cloud Providers",
          logos: [
            { name: "AWS", img: aws, description: "A comprehensive cloud platform offering a wide range of on-demand computing resources and services." },
            { name: "Google Cloud", img: google_cloud, description: "A suite of cloud computing services for scalable and reliable web applications." },
            { name: "Azure", img: azure, description: "Microsoft’s cloud computing platform offering a variety of services, including virtual machines, storage, and databases." }, 
            { name: "IBM Cloud", img: ibm, description: "IBM’s cloud platform offering a variety of tools for building, running, and managing applications in a hybrid and multi-cloud environment." },

          ],
        },
        {
          heading: "DevOps Tools",
          logos: [
            { name: "Docker", img: docker, description: "A platform for creating, deploying, and managing containers, ensuring consistent environments across development and production." },
            { name: "Kubernetes", img: kubernetes, description: "An open-source system for automating containerized application deployment, scaling, and management." },
            { name: "NGINX", img: tech10, description: "A high-performance web server and reverse proxy for serving dynamic web content." },
          ],
        },
      ],
    },
  ];

  const selectedContent = values.find((value) => value.title === selectedTech);

  return (
    <div className="tech-container">
      <h1>TECHNOLOGY STACK</h1>
      <hr />
      <div className="main-container">
        {/* Left Side */}
        <div className="left-panel-tech">
          {values.map((value) => (
            <div
              key={value.id}
              className={`menu-item-tech ${
                selectedTech === value.title ? "active" : ""
              }`}
              onClick={() => setSelectedTech(value.title)}
            >
              <span className="menu-item-tech-id">{value.id}</span>
              <span className="menu-item-tech-title">{value.title}</span>
            </div>
          ))}
        </div>

        <div className="vertical-line-tech"></div>

        {/* Right Side */}
        <div className="right-panel-tech">
          {selectedContent?.sections?.map((section, idx) => (
            <div key={idx} className="section-tech">
              <h2>{section.heading}</h2>
              <div className="logos-container">
                {section.logos.map((logo, index) => (
                  <div key={index} className="tech-card">
                    <img src={logo.img} alt={logo.name} />
                    <div>
                      <p>{logo.name}</p>
                      <small>{logo.description}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
